import { render } from "./BCollapsible.vue?vue&type=template&id=a633e1ce"
import script from "./BCollapsible.vue?vue&type=script&lang=js"
export * from "./BCollapsible.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__